module.exports = __webpack_public_path__ + "img/1F978.94299f96.svg";